import ThankYouPage from './ThankYouPage'

const ArchitectureNewScopeThankYou = () => (
    <ThankYouPage returnPath="/architecture" contentCategory="Architecture Scope" />
)

export default ArchitectureNewScopeThankYou
